import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import { usePermissions } from "../../common/PermissionContext";
import { useLocation, Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import Utils from "../../common/manipurCommon/Utils";

const TalentScouting = () => {

    const [talentScoutingList, setTalentScoutingList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [talentScoutingId, setTalentScoutingId] = useState("");
    const [testName, setTestName] = useState("");
    const [testDescription, setTestDescription] = useState("");
    const [talentScoutingStatus, setTalentscoutingStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchTalentScouting() {
            setIsLoading(true);
            const talntSctngResponse = await func.listTalentScouting();
            setTalentScoutingList(Array.isArray(talntSctngResponse) ? talntSctngResponse : [])
            setIsLoading(false);
        }
        fetchTalentScouting();
    }, [])

    const filteredData = talentScoutingList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const testNameRender = (rowData) => {
        return <span>{rowData.talentScoutingTestName}</span>;
    };

    const testDescriptionRender = (rowData) => {
        return <span>{rowData.talentScoutingTestDescription}</span>;
    };

    const testStatusRender = (rowData) => {
        return <span>{(rowData.talentScoutingStatus == 1) ? "Active" : "Inactive"}</span>;

    };

    const editDetails = (rowData: any) => {
        return (
            <Link to="#" onClick={() => editTalentScouting(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData: { talentScoutingId: any; }) => {
        const tlntId = rowData.talentScoutingId;

        return (
            <Link to="#" onClick={() => DeleteTalentScouting(tlntId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    function newTalentScouting() {
        setIsEdit(false)
        setOpenModal(true)
        setTestName("");
        setTestDescription("");
    }

    async function editTalentScouting(rowData: { talentScoutingId: any; }) {
        const tlntId = rowData.talentScoutingId;
        setIsEdit(true)
        setOpenModal(true)
        const getDetails = await func.getTalentScouting(tlntId);
        setTalentScoutingId(tlntId)
        setTestName(getDetails.talentScoutingTestName);
        setTestDescription(getDetails.talentScoutingTestDescription)
        setTalentscoutingStatus(getDetails.talentScoutingStatus);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateTalentScouting();
            } else {
                if (testName && testDescription) {
                    const formData = new FormData();
                    formData.append("talentscoutName", testName);
                    formData.append("talentscoutDescription", testDescription)

                    const createTlntSct = api.CreateTalentScouting;
                    fetch(createTlntSct, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            }
                        })
                }
            }
        }
    }

    function updateTalentScouting() {
        const formData = new FormData();
        formData.append("talentscoutName", testName);
        formData.append("talentscoutDescription", testDescription);
        formData.append("status", talentScoutingStatus);

        const updateTlntSct = api.UpdateTalentScouting + '/' + talentScoutingId;
        fetch(updateTlntSct, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function DeleteTalentScouting(tlntId: string) {
        const deleteTlntSctng = api.DeleteTalentScouting + '/' + tlntId;
        fetch(deleteTlntSctng, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items">
                                <div className="col-lg-12 text-center">
                                    <h4>Talent Scouting</h4>
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-md-4">
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn btn-secondary"
                                            onClick={() => { newTalentScouting() }}>
                                            <i className="feather-plus" />&nbsp;
                                            Create Talent Scouting Test
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-md-8 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="talentScoutingTestName"
                                                header="Talent Scouting Test Name"
                                                body={testNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="talentscoutDescription"
                                                header="Talent Scouting Test Description"
                                                body={testDescriptionRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="talentScoutingStatus"
                                                header="Status"
                                                body={testStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Talent Scouting Test</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Talent Scout Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="talentscoutName"
                                            value={testName}
                                            onChange={(e) => setTestName(e.target.value)}
                                            placeholder="Talent Scout Name" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Talent Scout Description</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="talentscoutDescription"
                                            value={testDescription}
                                            onChange={(e) => setTestDescription(e.target.value)}
                                            placeholder="Talent Scout Description" />
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={talentScoutingStatus === '1'}
                                                        id="sportStatus"
                                                        onChange={(e) => {
                                                            setTalentscoutingStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                )
            }
        </>
    );
};

export default TalentScouting;